import { applySnapshot, flow, getParent, getSnapshot } from 'mobx-state-tree';
import { getIdentifier } from '~/mst/utils';

import api from '~/api';
import type { IReportsModel } from '~/mst/models/reports/model';
import { IReportModel } from './model';

export default (self: IReportModel) => ({
  update: flow(function* update(values) {
    self.startSyncing();
    try {
      yield api.reports.update(getIdentifier(self)!, values);
      if (values) {
        Object.assign(self, values);
      }
      self.finishSyncing();
    } catch (error) {
      self.failSyncing(error);
    }
  }),
  fetch: flow(function* fetch(options = {}) {
    try {
      self.startFetching();
      const { data } = yield self.sync(api.reports.read, getIdentifier(self)!, options);
      if (data.assets.length === 0) {
        self.finishFetching();
        return;
      }
      applySnapshot(self, {
        ...data,
        assets: { models: data.assets.map((asset: any) => ({ ...asset, id: `${getIdentifier(self)}_${asset.period_key}` })) }
      });
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  }),
  clone: flow(function* clone(values) {
    self.startSyncing();
    try {
      const { data } = yield api.reports.clone(getIdentifier(self)!, values || getSnapshot(self));
      const reports = getParent<IReportsModel>(self, 2);
      reports.add(data);
      self.finishSyncing();
      return data;
    } catch (error) {
      self.failSyncing(error);
    }
    return null;
  })
});
